module.exports = __webpack_public_path__ + "static/img/16.311e954.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/11/sp/16.png
// module id = jmYM
// module chunks = 0